import { createAction } from '@reduxjs/toolkit';

import type {
  ConsultaDocumentoNotificacao,
  ConsultaDocumentoNotificacaoThunk,
  FalhaConsultaDocumentoNotificacao,
  ResultadoConsultaDocumentoNotificacao,
} from '../../types/documentoNotificacao.types';
import { resumoDocumentoNotificacao } from '../../utils/documentoNotificacao';
import { consultarDocumentoNotificacao } from './services';

export const consultaDocumentoIniciada = createAction<ConsultaDocumentoNotificacao>(
  'extrajudicialDocumentoNotificacao/consultaIniciada',
);
export const consultaDocumentoConcluida = createAction<ResultadoConsultaDocumentoNotificacao>(
  'extrajudicialDocumentoNotificacao/consultaConcluida',
);
export const consultaDocumentoFalhou = createAction<FalhaConsultaDocumentoNotificacao>(
  'extrajudicialDocumentoNotificacao/consultaFalhou',
);
export const limparConsultaDocumento = createAction<string>(
  'extrajudicialDocumentoNotificacao/limparConsulta',
);

/** A URL retorna só ao modal; ações e estado Redux recebem apenas o resumo da consulta. */
export function obterDocumentoNotificacao(
  numeroNotificacao: string,
  signal: AbortSignal,
): ConsultaDocumentoNotificacaoThunk {
  return async (dispatch, getState) => {
    const consulta = { numeroNotificacao, consultaId: crypto.randomUUID() };
    dispatch(consultaDocumentoIniciada(consulta));
    try {
      const documento = await consultarDocumentoNotificacao(numeroNotificacao, signal);
      signal.throwIfAborted();
      if (getState().extrajudicialDocumentoNotificacao.consultaId !== consulta.consultaId)
        return null;
      dispatch(
        consultaDocumentoConcluida({
          ...consulta,
          documento: resumoDocumentoNotificacao(documento),
        }),
      );
      return documento;
    } catch (erro) {
      if (!signal.aborted) {
        dispatch(
          consultaDocumentoFalhou({
            ...consulta,
            erro: 'Não foi possível atualizar a consulta. Tente novamente.',
          }),
        );
      }
      throw erro;
    }
  };
}
